import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2584f6fb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cascading-select" }
const _hoisted_2 = {
  key: 0,
  class: "c-title"
}

import { OfficePlusTreeNode } from '@/services/officeplus-http.service';
import { computed, PropType, ref, watch, onMounted, onBeforeUnmount } from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: {
  title: {
    type: String,
    default: '',
  },
  treeNodes: {
    type: Array as PropType<OfficePlusTreeNode[]>,
    required: true,
  },
  defaultValue: {
    type: Array as PropType<number[]>,
    default: () => [],
  },
  menuHeight: {
    type: [Number, String],
    default: null,
  },
},
  emits: ['change'],
  setup(__props, { emit }) {

const props = __props





// 创建树形数据的映射，方便查找
const nodeMap = ref<Record<number, OfficePlusTreeNode>>({});
// 选中的值，用于级联选择器
const selectedValue = ref<number[]>([]);

// 生成唯一ID
const uid = Math.random().toString(36).substring(2, 10);

onMounted(() => {
  // 设置级联选择器的下拉高度
  // 为什么要这样做？element plus 不支持设置下拉高度
  // 如果放在全局样式中，那么所有的级联选择器都会受到影响
  if (props.menuHeight) {
    const styleEl = document.createElement('style');
    styleEl.setAttribute('data-cascader-id', uid);
    const height = typeof props.menuHeight === 'number' ? `${props.menuHeight}px` : props.menuHeight;

    styleEl.textContent = `
      .el-popper.cascader-${uid} .el-cascader-menu__wrap.el-scrollbar__wrap {
        height: ${height} !important;
      }
    `;
    document.head.appendChild(styleEl);
  }
});

// 移除自定义样式
onBeforeUnmount(() => {
  const styleEl = document.querySelector(`style[data-cascader-id="${uid}"]`);
  if (styleEl) {
    styleEl.remove();
  }
});
// 级联选择器选项
const cascaderOptions = ref<any[]>([]);

// 级联选择器属性配置
const cascaderProps = {
  value: 'id',            // 指定选项的值为节点id
  label: 'name',          // 指定选项标签为节点name
  children: 'children',   // 指定子选项为节点children
  checkStrictly: false,   // 严格的遵守父子节点不互相关联
  emitPath: true          // 返回选中节点的路径数组
};

// 将OfficePlusTreeNode数组转换为级联选择器格式的选项
function convertToCascaderOptions(nodes: OfficePlusTreeNode[]) {
  // 深拷贝节点数据，防止修改原始数据
  return JSON.parse(JSON.stringify(nodes));
}

// 创建节点ID到节点的映射
function buildNodeMap(nodes: OfficePlusTreeNode[]) {
  const map: Record<number, OfficePlusTreeNode> = {};

  function traverse(node: OfficePlusTreeNode) {
    map[node.id] = node;
    if (node.children && node.children.length > 0) {
      node.children.forEach(child => traverse(child));
    }
  }

  nodes.forEach(node => traverse(node));
  return map;
}

// 初始化数据
watch(() => props.treeNodes, (newNodes) => {
  if (newNodes && newNodes.length > 0) {
    // 构建节点映射
    nodeMap.value = buildNodeMap(newNodes);
    // 转换为级联选择器需要的格式
    cascaderOptions.value = convertToCascaderOptions(newNodes);
    // 设置默认值
    if (props.defaultValue.length > 0) {
      selectedValue.value = props.defaultValue;
    }
  }
}, { immediate: true });

// 处理级联选择器变化
function handleCascaderChange(value: number[]) {
  // 获取最后一级选中的节点
  const selectedId = value.length > 0 ? value[value.length - 1] : null;
  const selectedNode = selectedId !== null ? nodeMap.value[selectedId] : null;

  // 构建路径字符串
  const pathNames = value.map(id => nodeMap.value[id]?.name || '').filter(Boolean);
  const pathString = pathNames.join(' / ');

  // 触发change事件
  emit('change', {
    ids: value,          // 所有选中节点的ID数组
    id: selectedId,      // 最后一级选中的节点ID
    node: selectedNode,  // 最后一级选中的节点对象
    path: pathString     // 路径字符串，如 "分类1 / 子分类 / 子子分类"
  });
}

return (_ctx: any,_cache: any) => {
  const _component_el_cascader = _resolveComponent("el-cascader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(__props.title), 1))
      : _createCommentVNode("", true),
    _createVNode(_component_el_cascader, {
      modelValue: selectedValue.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedValue).value = $event)),
      options: cascaderOptions.value,
      props: cascaderProps,
      placeholder: "请选择",
      style: {"width":"100%"},
      filterable: "",
      clearable: "",
      "popper-class": `cascader-${_unref(uid)}`,
      onChange: handleCascaderChange
    }, null, 8, ["modelValue", "options", "popper-class"])
  ]))
}
}

})